import { useBudgetEdit } from 'app/components/location-settings-budget-edit/useBudgetEdit'
import { BudgetEditComponent } from 'app/components/location-settings-budget-edit/BudgetEditComponent'

export default function EditBudget() {
  const props = useBudgetEdit()
  return <BudgetEditComponent {...props} />
}
